import SmartSearchDateIntervalSelectAndActionsLayout from "../../../components/Layouts/smart-search-date-interval-select-and-actions-layout";
import { ActionButtonEnum } from "../../../enums/actionButtonEnum";
import { SearchOptionEnum } from "../../../enums/searchOptionEnum";
import { SmartSearchParams } from "../../../hooks/useSmartSearchParams";
import {
  GetClosedPullTabGamesParams,
  getClosedPullTabGames,
} from "../../../services/reports";
import { Output } from "../../../services/types";
import { createIdFromSmartSearchParams } from "../../../utils/smartSearch";
import {ValidationEnum} from "../../../enums/validationEnum";
import dayjs from "dayjs";

const ReportClosedGame = () => {
  return (
    <SmartSearchDateIntervalSelectAndActionsLayout
      searchBy={[
        SearchOptionEnum.DISTRIBUTOR,
        SearchOptionEnum.CHARITY,
        SearchOptionEnum.LOCATION,
      ]}
      actions={[
        ActionButtonEnum.REFRESH,
        ActionButtonEnum.SAVE_CSV,
        ActionButtonEnum.SAVE_PDF,
      ]}
      validations={[
          ValidationEnum.VALIDATE_SMART_SEARCH,
          ValidationEnum.VALIDATE_SEARCH,
      ]}
      validOnEmpty={false}
      onRefresh={(
        output: Output,
        params: SmartSearchParams,
        startDateInterval: dayjs.Dayjs,
        endDateInterval: dayjs.Dayjs
      ) => {
        const getClosedPullTabGamesParams: GetClosedPullTabGamesParams = {
          name: "Closed Pull-Tab Games",
          output,
          dateIntervalStart: startDateInterval.format("MM-DD-YYYY"),
          dateIntervalEnd: endDateInterval.format("MM-DD-YYYY"),
        };

        if (params.id) {
          const id = createIdFromSmartSearchParams(params);
          getClosedPullTabGamesParams[id] = params.id;
        }

        return getClosedPullTabGames(getClosedPullTabGamesParams);
      }}
    />
  );
};

export default ReportClosedGame;
